import { Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import LinearProgressWIthLabel from "./_atoms/LinearProgressWIthLabel";

const STORAGE_USAGE_PERCENTAGE = 0.1;

const StorageUsageProgress = () => {
    return (
        <Stack border={1} borderRadius={2} borderColor="#ccc" px={2} py={1} flexDirection="column" mt={2}>
            <LinearProgressWIthLabel value={STORAGE_USAGE_PERCENTAGE} label="0,1%" />
            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                <strong>5 MB</strong> di <strong>5 GB</strong> utilizzati;
            </Typography>
        </Stack>
    );
};

export default StorageUsageProgress;
